import { render, staticRenderFns } from "./1004.vue?vue&type=template&id=461789e1&scoped=true&"
import script from "./1004.vue?vue&type=script&lang=js&"
export * from "./1004.vue?vue&type=script&lang=js&"
import style0 from "./1004.vue?vue&type=style&index=0&id=461789e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461789e1",
  null
  
)

export default component.exports